import React, {PureComponent} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import PropTypes from 'prop-types'
import {Container} from 'reactstrap'
import {connect} from 'react-redux'

import AdminNavbar from '../components/AdminNavbar'
import Drivers from './driver/Drivers'
import Families from './family/Families'
import Dashboard from './dashboard/dasboard'
import {userLogout} from '../actions/AuthActions'

class AdminScreen extends PureComponent {
  render() {
    if (!this.props.isLoggedIn) return <Redirect to="/login"/>
    if (!this.props.isAdmin) return <Redirect to="/acesso-negado"/>

    return (
      <div>
        <AdminNavbar
          logout={this.props.userLogout}
        />
        <main className="main">
          <Container fluid>
            <Switch>
            
              <Route path="/maetoristas" component={Drivers} />
              <Route path="/familias" component={Families} />
              <Route path="/dashboard" component={Dashboard} />

              <Redirect exact from='/' to='/dashboard'/>
            </Switch>
          </Container>
        </main>
      </div>
    );
  }
}

AdminScreen.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

export default connect(state => ({
  isLoggedIn: !!state.user.token,
  isAdmin: state.user.role === 'admin',
}), {
  userLogout,
})(AdminScreen)



// WEBPACK FOOTER //
// ./src/screens/AdminScreen.js